module.exports = __webpack_public_path__ + "static/durcanova-e23b7788a520cb4c50ba44cc4782f3a6.jpg";